export const form = `
<div class="mb-2 d-flex flex-column align-items-end position-relative">
<button
    class="btn btn-primary btn-md"
    ref="header"
>
    <span class="mb-0 card-title {% if (ctx.component.theme && ctx.component.theme !== 'default') { %}text-light{% } %}" style="color: #ffffff">
        {{ctx.t(ctx.component.buttonName, { _userInput: true }) || "Button"}}
    </span>
</button>
{% if (ctx.collapsed || ctx.builder) { %}
<div class="card-body position-absolute dropdownContainer" ref="{{ctx.nestedKey}}" id="{{ctx.instance.id}}-{{ctx.component.key}}" style="top: 3.5rem;z-index: 100;">
    {{ctx.children}}
</div>
{% } %}
</div>`;
